import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AssigneeDropdownTemplate from "@Shared/@HandlebarsTemplates/general/_assignee-dropdown.hbs";
import { mapActions, mapGetters } from "vuex";
import { LOAD_AGENTS } from "../store/agent-actions";
import Amplitude from "../../../../../shared/utils/amplitude";
import { isEmpty, cloneDeep } from "lodash";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
export default defineComponent({
  name: "AgentsSelect",
  components: {
    vSelectField,
    MaterialInput
  },
  inject: {
    formatSelect2Data: {
      default: null
    }
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: null
    },
    value: {
      type: [Array, String],
      default: () => null
    },
    materialDesign: {
      type: Boolean,
      default: true
    },
    spaceClasses: {
      type: String,
      default: "col-12 mt-3 pb-4 px-0"
    },
    currentUsername: {
      type: String,
      default: ""
    },
    dropdownParent: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    avatarClass: {
      type: String,
      default: ""
    },
    agentUsernamesToInclude: {
      type: Array,
      default: null
    },
    selectOptions: {
      type: Object,
      default: () => ({})
    },
    extraSelectData: {
      type: Array,
      default: () => []
    },
    closeOnSelectAll: {
      type: Boolean,
      default: false
    },
    ignoreCurrentAgent: {
      type: Boolean,
      default: false
    },
    isApplicationBoard: {
      type: Boolean,
      default: false
    },
    hasActiveFilters: {
      type: Boolean,
      default: false
    },
    hasCheckboxes: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [String, Object, Array],
      default: null
    }
  },
  data() {
    return {
      allReferrers: [],
      loading: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AgentStore", ["agents"])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), {}, {
    options() {
      const formatResult = state => $(AssigneeDropdownTemplate(_objectSpread(_objectSpread({}, state), {}, {
        avatarClass: this.avatarClass
      })));
      return _objectSpread({
        templateResult: this.formatSelect2Data || formatResult,
        allowClear: false,
        closeOnSelect: !this.multiple,
        dropdownCssClass: "agents-vue-select",
        dropdownParent: this.dropdownParent,
        matcher: this.matchCustom,
        escapeMarkup(markup) {
          return markup;
        }
      }, this.selectOptions);
    },
    formGroupClass() {
      if (this.materialDesign) return "form-group-material";
      return "form-group";
    },
    currentAgentUsername() {
      return this.CURRENT_USER_USERNAME || "";
    },
    currentUser() {
      if (this.hasActiveFilters) {
        // display the first filtered agents in 'Showing Applications for'
        return this.filteredAgents[0];
      } else if (this.value == "all") {
        // display default value in reports page
        return this.value;
      } else if (this.defaultValue) {
        return this.defaultValue;
      } else {
        var _context;
        // Displaying the full name in 'Showing Applications for'
        const agent = _filterInstanceProperty(_context = this.agents).call(_context, ({
          username
        }) => username === this.value);
        return agent;
      }
    },
    filteredAgents() {
      var _context4, _context5, _context7;
      if (this.ignoreCurrentAgent && this.currentAgentUsername) {
        var _context2, _context3;
        const agentsWithoutCurrent = _filterInstanceProperty(_context2 = this.agents).call(_context2, ({
          username
        }) => username !== this.currentAgentUsername);
        return _mapInstanceProperty(_context3 = [...this.extraSelectData, ...agentsWithoutCurrent]).call(_context3, agent => {
          agent.fullName = agent.givenName + " " + agent.familyName;
          agent.id = agent.username;
          return agent;
        });
      }
      if (isEmpty(this.agentUsernamesToInclude)) return _mapInstanceProperty(_context4 = [...this.extraSelectData, ...this.agents]).call(_context4, agent => {
        agent.fullName = agent.givenName + " " + agent.familyName;
        agent.id = agent.username;
        return agent;
      });
      const filterAgents = _filterInstanceProperty(_context5 = this.agents).call(_context5, ({
        username
      }) => {
        var _context6;
        return _includesInstanceProperty(_context6 = this.agentUsernamesToInclude).call(_context6, username);
      });
      return _mapInstanceProperty(_context7 = [...this.extraSelectData, ...filterAgents]).call(_context7, agent => {
        agent.fullName = agent.givenName + " " + agent.familyName;
        agent.id = agent.username;
        return agent;
      });
    },
    computedLabel() {
      var _this$label;
      return (_this$label = this.label) != null ? _this$label : this.$tc("agents.selectAgent", this.multiple ? 2 : 1);
    }
  }),
  watch: {
    loading: {
      handler(value) {
        this.$emit("loading", value);
      },
      immediate: true
    }
  },
  async mounted() {
    if (!this.filteredAgents.length) {
      this.loading = true;
      await this.LOAD_AGENTS();
      this.loading = false;
    }
    this.$nextTick(() => {
      var _this$$refs, _this$$refs$select;
      (_this$$refs = this.$refs) == null ? void 0 : (_this$$refs$select = _this$$refs.select) == null ? void 0 : _this$$refs$select.initSelect2();
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AgentStore", [LOAD_AGENTS])), {}, {
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, ref => _objectSpread(_objectSpread({}, ref), {}, {
        id: ref.username,
        text: `${ref.givenName} ${ref.familyName}
          ${this.currentUsername === ref.username ? `(${this.$t("global.words.you")})` : ""}`
      }));
    },
    handleChange(data, type) {
      if (type === "deselected" && !data) {
        return;
      }
      this.$emit("change", data, type);
      this.logHandleChange(data, type);
    },
    handleSelectOpen(event) {
      Amplitude.logEvent("Agent Select - opened", {
        action: "open"
      });
      this.$emit("open", event);
    },
    logHandleChange(data, type) {
      var _data$username;
      const eventName = "Agent Select -";
      Amplitude.logEvent(`${eventName} ${type}`, {
        data: {
          id: (_data$username = data == null ? void 0 : data.username) != null ? _data$username : data.id
        },
        action: type
      });
    },
    matchCustom(params, data) {
      var _params$term$toLowerC, _params$term, _data$text$toLowerCas, _data$text, _data$email$toLowerCa, _data$email, _context8;
      const term = (_params$term$toLowerC = params == null ? void 0 : (_params$term = params.term) == null ? void 0 : _params$term.toLowerCase()) != null ? _params$term$toLowerC : "";
      const isTermEmpty = isEmpty(_trimInstanceProperty(term).call(term));
      if (isTermEmpty) return data;
      const name = (_data$text$toLowerCas = (_data$text = data.text) == null ? void 0 : _data$text.toLowerCase()) != null ? _data$text$toLowerCas : "";
      const email = (_data$email$toLowerCa = (_data$email = data.email) == null ? void 0 : _data$email.toLowerCase()) != null ? _data$email$toLowerCa : "";
      if (_includesInstanceProperty(_context8 = `${name} ${email}`).call(_context8, term)) return data;
      return null;
    }
  })
});